module.exports = __webpack_public_path__ + "img/avatar_profile.e2377037.png";